module.exports = __webpack_public_path__ + "static/media/Calculator_Hero_Mobile.69880903.png";